
import { mapGetters, mapState, mapActions } from 'vuex';
import store from '@/store';
import marked from 'marked';
import * as types from '@/store/mutation-types';
import Breadcrumb from '@components/Breadcrumb.vue';
import Sidebar from '@components/Sidebar.vue';
import ReviewPanel from '@components/ReviewPanel.vue';
import ArchiveDownload from '@components/ArchiveDownload.vue';
import { UrlStatePayload } from '../types';
import { DateTime } from 'luxon';

export default {
  created() {
    this.updatePath();
  },

  watch: {
    $route: 'updatePath',
  },

  computed: {
    ...mapGetters(['currentDirectory']),

    ...mapState(['loading', 'error', 'lights', 'sidebar']),

    classes() {
      const classes = [];

      classes.push(this.lights ? 'light' : 'dark');

      return classes;
    },

    error_message() {
      if (!this.error.message) {
        return '';
      }

      return marked(this.error.message);
    },
  },

  methods: {
    ...mapActions(['updateStateFromUrl']),

    updatePath() {
      const { query, path } = this.$route;
      const payload: UrlStatePayload = { path };

      ['lights', 'sidebar'].forEach(key => {
        if (Object.prototype.hasOwnProperty.call(query, key)) {
          payload[key] = Boolean(Number(query[key]));
        }
      });

      if (
        Object.prototype.hasOwnProperty.call(query, 'date') &&
        Object.prototype.hasOwnProperty.call(query, 'tz')
      ) {
        const travelTo = Number(query.date);

        if (!isNaN(travelTo)) {
          payload.date = travelTo;
          payload.tz = query.tz;
        }
      } else {
        const now = DateTime.local();
        payload.date = now.toMillis();
        payload.tz = query.tz || now.zoneName;
      }

      this.updateStateFromUrl(payload);

      if (!this.currentDirectory) {
        this.$store.dispatch('fetchStructure', { path });
      }
    },
  },

  components: {
    ArchiveDownload,
    Sidebar,
    ReviewPanel,
    Breadcrumb,
  },
};
